var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"analysisIframe",staticStyle:{"padding":"0","margin":"0","border":"0","width":"100%","height":"810px"},attrs:{"src":_vm.htmlPath}})
}
var staticRenderFns = []

export { render, staticRenderFns }